import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react'
import { initPushOnLogin } from '../../lib/pushNotifications'

export const PUSH_PROMPT_DISMISSED_KEY = 'push_prompt_dismissed'

export default function PushPermissionModal({ open, onClose, tenantId }) {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  if (!open) return null

  function dismiss() {
    localStorage.setItem(PUSH_PROMPT_DISMISSED_KEY, '1')
    onClose()
  }

  async function handleEnable() {
    setLoading(true)
    try {
      await initPushOnLogin(tenantId)
    } catch (err) {
      Sentry.captureException(err, { tags: { action: 'push_permission_modal_enable' }, extra: { tenantId } })
    } finally {
      setLoading(false)
      // Permission is no longer 'default' after this (granted or denied) — never ask again.
      localStorage.setItem(PUSH_PROMPT_DISMISSED_KEY, '1')
      onClose()
    }
  }

  return (
    <div
      className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4"
      onClick={(e) => { if (e.target === e.currentTarget) dismiss() }}
    >
      <div className="bg-white rounded-2xl w-full max-w-sm shadow-xl p-5">
        <div className="text-base font-bold text-gray-900 mb-2">
          {t('pushPermissionModal.title')}
        </div>
        <p className="text-sm text-gray-600 mb-5">
          {t('pushPermissionModal.body')}
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={dismiss}
            disabled={loading}
            className="flex-1 py-2.5 rounded-xl text-sm font-semibold text-gray-600 bg-gray-100 disabled:opacity-50"
          >
            {t('pushPermissionModal.laterButton')}
          </button>
          <button
            type="button"
            onClick={handleEnable}
            disabled={loading}
            className="flex-1 py-2.5 rounded-xl text-sm font-semibold text-white bg-[#1535c8] disabled:opacity-50"
          >
            {t('pushPermissionModal.enableButton')}
          </button>
        </div>
      </div>
    </div>
  )
}
